export enum EstadoRefacturacion {
  Candidata,
  ValidacionComercial,
  Pendiente,
  Revisado,
  Aprobado,
  Rechazado
}
